module.exports = [
  'No error, everything ok.',
  'CBOR parser failure.',
  'Driver could not understand the command.',
  'Driver expected an image file in binary data, but could not read one.',
  'Client attempted to draw to a Looking Glass that is not connected or has no calibration.',
  'Client attempted to load a nonexistent key from the cache.',
  'Client attempted to register an app ID after sending one or more messages.',
  'Client attempted to do something that is not allowed (i.e., tried to take over a display currently occupied by a greedy process).'
];
